import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { AccountBalanceComponent } from './account-balance.component';
import { PipesModule } from 'src/app/pipes/pipes.module';


@NgModule({
  declarations: [
    AccountBalanceComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    PipesModule
  ]
})
export class AccountBalanceModule {}